import { Duration, milliseconds } from 'date-fns'
import { useTranslation } from 'react-i18next'
import AlertContainer from './AlertContainer'

const PauseAndGoToDropoffAlert = ({ timeToDropoff }: { timeToDropoff: Duration }) => {
  const { t } = useTranslation('navigation')
  const showDropoff = milliseconds(timeToDropoff) === 0

  if (!showDropoff) {
    return null
  }

  return (
    <AlertContainer
      type="alert"
      alertColor="orange"
      alertText={t('pauseAndGoToDropoff')}
      position="bottom"
      opacity="high"
      height="tiny"
    />
  )
}

export default PauseAndGoToDropoffAlert
